import Modal from 'react-modal';
import api from '../../../../config';
import { toast } from 'react-toastify';
import './index.css';
import { showMessageError } from '../../../../classes/functions';

export default function ModalStartSeparation({customStyles, showModalStartSeparation, setShowModalStartSeparation, id, setCarrying, setStatus}){
    function startSeparation() {
        setCarrying(true);

        //API original: `/api/product_requests/setStartSeparation?id=${id}`
        //API para o futuro: `/api/products_requests/${id}/iniciarSeparacao`
        api.put(`/api/products_requests/${id}/iniciarSeparacao`)
        .then((response) => {
          setStatus(response.data.row.status);
          toast.success('Separação Iniciada com Sucesso.');
          setShowModalStartSeparation(false)
          setCarrying(false);
        }).catch((error) => {
          setCarrying(false);
          console.log(error);
          showMessageError(error.response.data);
        });
      }
    
    return (
        <Modal 
          isOpen={showModalStartSeparation} 
          onRequestClose={() => setShowModalStartSeparation(false)} 
          className="modal-start-separation"
          overlayClassName="modal-overlay"
          contentLabel="Iniciar Separação" 
          ariaHideApp={false}
        >
            <div className="body-modal">
            <div className="divGroup">
                <h3>Deseja realmente iniciar a separação?</h3>
            </div>
            <div className="formDiv">
                <button type="button" className="buttonSubmit" onClick={startSeparation}>Confirmar</button>
                <button type="button" className="buttonCancel" onClick={() => setShowModalStartSeparation(false)}>Fechar</button>
            </div>
            </div>
      </Modal>
    )
}